import SVGDownload from "components/_common/icons/vdm/SVGDownload";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "redux/store";
import MetricGauge from "./MetricGauge";

type OwnProps = {};
type KeyMetricsProps = PropsFromRedux & OwnProps;
function KeyMetrics(props: KeyMetricsProps) {
	return (
		<div className="mt-4 bg-[#fefeff] p-6 rounded-md shadow-md border border-gray-200">
			<div className="flex justify-between items-center border-b border-gray-200 pb-4">
				<h3 className="text-xl font-medium">Key Metrics</h3>
				<div>
					<SVGDownload />
				</div>
			</div>
			<div className="flex flex-row gap-4 justify-evenly flex-wrap lg:flex-nowrap mt-4">
				<MetricGauge
					range={[0, 100]}
					statusRanges={{
						veryLow: [-Infinity, 10],
						inRange: [10, 80],
						veryHigh: [80, Infinity],
					}}
					title="Methane Number"
					value={73.4}
					fillColor="#fdc84b"
				/>
				<MetricGauge
					range={[0, 2]}
					statusRanges={{
						veryLow: [-Infinity, 0.4],
						inRange: [0.4, 1.6],
						veryHigh: [1.6, Infinity],
					}}
					title="Tank Avg. Pressure (bar g)"
					value={1.8}
					fillColor="#ff7c7c"
				/>
				<MetricGauge
					range={[0, 3800]}
					statusRanges={{
						veryLow: [-Infinity, 100],
						inRange: [100, 2600],
						veryHigh: [2600, Infinity],
					}}
					title="ROB total (m3)"
					value={2520}
					fillColor="#7cd4fc"
				/>
				<MetricGauge
					range={[0, 12]}
					statusRanges={{
						veryLow: [-Infinity, 3],
						inRange: [3, 9],
						veryHigh: [9, Infinity],
					}}
					title="Tank Avg. Pressure (bar g)"
					value={8.3}
					fillColor="#7cd4fc"
				/>
			</div>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(KeyMetrics);
